// extracted by mini-css-extract-plugin
export default {"topBannerTitle":"CommunityPage-module--topBannerTitle--7edf2","topBannerDescription":"CommunityPage-module--topBannerDescription--bd084"};